import DomeTurretIcon from "../../assets/product-list-assets/dome-turret.svg";
import type { ProductListGroup } from "../../types";

export const domeTurret: ProductListGroup = {
  id: "domeTurret",
  title: "productListGroup.domeTurret.title",
  icon: {
    src: DomeTurretIcon,
    width: 30,
    height: 21,
  },
};
